<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow
          routeBack="FeedbackIndex"
          :title="feedbackTrad(feedback.type) + ' - ' + feedback.farmer.tostring"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm" v-if="feedback.id">

            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Feedback.farmer') }}</div>
                  <div class="textual-link" @click="goToFarmer(feedback.farmer.id )">
                    {{ feedback.farmer.tostring }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Feedback.date') }}</div>
                  <div>{{ new Date(feedback.creationDate) | moment("Do MMMM YYYY - HH:mm") }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Feedback.type') }}</div>
                  <div> {{feedbackTrad(feedback.type) }}</div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="d-flex flex-column mb-4 custom-border">
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Feedback.description') }}</div>
                  <div> {{ feedback.description }}</div>
                </div>
              </div>

            </div>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'

export default {

  name: 'FeedbackShow',

  components: {
    BackArrow,
    DateField
  },

  data () {
    return {
      feedbackId: this.$route.params.feedbackId,
      feedback: {}
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    async fetchData () {
      if (this.feedbackId) {
        await this.fetchFeedback()
      }
    },

    async fetchFeedback () {
      api
        .get('/feedback/' + this.feedbackId)
        .then(response => {
          this.feedback = response.data
        })
    },

    feedbackTrad (value) {
      return this.$i18n.t(value)
    },

    goToFarmer (id) {
      this.$router.push({
        name: 'FarmerShow',
        params: {
          farmerId: id
        }
      })
    }
  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/feedback/FeedbackShow.vue